/* eslint-disable no-console */

import { register } from 'register-service-worker'

const userAgent = window.navigator.userAgent;
const isIosSafari = /iPhone|iPad|iPod/i.test(userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

if (process.env.NODE_ENV === 'production' && !isIosSafari) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; please refresh.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
} else if (isIosSafari && 'serviceWorker' in navigator) {
  // PWA is temporarily disabled on iOS Safari. Remove registrations left by
  // previous releases so Safari always loads the browser version.
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => registration.unregister())
  })
}
